import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  transform: "scale(1.2,1.2)",
  stroke: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  class: "logo-border-line",
  d: "m269.13,269.23c4.93,4.58,12.15,7.69,18.16,10.63,15.04,7.37,31.14,11.83,46.86,17.45,22.34,8,44.65,16.1,66.95,24.22,11.15,4.06,22.29,8.14,33.44,12.2,9.66,3.53,19.55,6.21,29.09,9.98,3.82,1.51,9.63,3.4,11.85,7.2.07.12,0,.28-.14.3-12.97,2.57-25.49-3.24-37.52-7.23-9.64-3.2-19.67-4.94-29.46-7.59-4.61-1.25-8.71-2.49-12.98-4.51-1.99-.94-8.4-4.74-10.56-2.68.73.87.39,2.18-.69,2.53-3.62,1.16-8.11-.28-11.48-1.37-5.22-1.68-9.16-5.69-16.05-4.16,0,0,.01.02.02.02.79,1.22-.26,2.81-1.7,2.61-1.26-.17-2.51-.59-3.68-1.11-6.01-2.66-10.48-4.76-17.28-4.54-8.19.26-16.41,1.54-24.6,2.06-9.24.59-18.52.87-27.77,1.3-16.64.77-32.84,2.93-49.38,4.5s-32.2,1.19-47.28-4.34c-16.43-6.04-30.65-16.97-42.57-29.62-6.58-6.98-12.67-14.41-18.55-21.98-2.98-3.84-5.91-7.72-8.82-11.62-3.65-4.88-6.57-9.16-11.95-12.39-7.66-4.59-16.22-7.51-25.09-8.54-9.74-1.14-19.72.74-29.35-.43-.2-2.78,1.86-6.21,3.66-8.25,2.82-3.18,6.17-5.85,9.84-8.01l9.16-5.38c4.79-13.42,12.42-24.37,25.78-29.32l1.73-.73c11.76-3.39,16.5-2.28,23.21-.65,4.81,1.17,21.76,7.99,25.86,10.76l17.28,8.97-18.91-9.81c.13-.13,4.1-7.54,4.24-7.66,6.38-9.72,1.52-42.75,5.85-49.63,11.04-17.54,23.16-34.23,35.84-50.61,11.84-15.29,21.47-32.23,35.21-46,.15-.15.41-.05.41.17-.1,5.48.6,14.54-1,20.08-1.51,5-5.02,23.91-7.86,32.98-.71,2.26-.45,4.71.69,6.78l8.11,14.76"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  class: "logo-border-line",
  d: "m269.13,269.23c-2.78-2.5-14.82-14.97-11.06-14.94,46.5-8.42,120.91-59.58,77.36-59.65l-5.66.16c12.99-13.46,28.49-39.86,26.56-39.78-3.49-3.49-15.12-2.98-19.9-2.7-2.23.13-4.45.39-6.66.7,4.86-1.13,23.36-15.6,26.56-19.04,17.3-18.56,33.91-37.8,52.07-55.54,9.63-7.35,18.44-16.21,26.69-25.05,4.27-4.58,15.77-14.59,14.76-21.85-.04-.3-.36-.48-.64-.36-10.77,4.72-22.17,8.86-33.52,12.72-19.93,6.78-38.61,14.34-59.29,19.44-10.2,2.52-19.95,5.37-30.02,7.79-5.03,1.21-9.9,2.8-14.85,3.95-3.97.92-7.84,2.43-13.82,3.63-7.33,2.17-13.96,3.99-19.66,6.06-7.6,2.77-17.31,7.28-25.66,11.67-10.46,5.49-18.47,14.05-24.66,24.12-1.35,2.19-2.52,5.4-3.68,7.96-2.58,5.67-4.25,10.14-7.27,15.59-7.69,13.87-12.13,32.21-23.74,44.24"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  class: "logo-body-line",
  d: "m 72.57 223.16 c 10.34 0 22.43 5.84 31.02 0 s 19.41 -5.16 26.14 2.71 s 24.22 79.76 93.59 87.23 c 69.37 7.47 104.45 7.73 114.57 7.73"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("line", {
  class: "logo-wing-line",
  x1: "291.42",
  y1: "116.78",
  x2: "312.14",
  y2: "165.41"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("line", {
  class: "logo-wing-line",
  x1: "311.81",
  y1: "164.63",
  x2: "324.99",
  y2: "196.31"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("line", {
  class: "logo-wing-line",
  x1: "258.07",
  y1: "137.66",
  x2: "258.07",
  y2: "176.66"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("line", {
  class: "logo-wing-line",
  x1: "227.98",
  y1: "127",
  x2: "221.6",
  y2: "163.59"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("line", {
  class: "logo-wing-line",
  x1: "312.14",
  y1: "165.41",
  x2: "283.67",
  y2: "205.59"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("line", {
  class: "logo-wing-line",
  x1: "329.78",
  y1: "134.41",
  x2: "312.14",
  y2: "167.02"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("line", {
  class: "logo-wing-line",
  x1: "324.99",
  y1: "196.31",
  x2: "306.05",
  y2: "230.68"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("line", {
  class: "logo-wing-line",
  x1: "291.42",
  y1: "116.78",
  x2: "258.27",
  y2: "177.12"
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("line", {
  class: "logo-wing-line",
  x1: "282.51",
  y1: "206.64",
  x2: "258.07",
  y2: "254.29"
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("line", {
  class: "logo-wing-line",
  x1: "335.85",
  y1: "89.39",
  x2: "290.62",
  y2: "117.27"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("line", {
  class: "logo-wing-line",
  x1: "378.78",
  y1: "61.34",
  x2: "336.59",
  y2: "89.39"
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("line", {
  class: "logo-wing-line",
  x1: "258.27",
  y1: "137.21",
  x2: "262.08",
  y2: "94.62"
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("line", {
  class: "logo-wing-line",
  x1: "291.42",
  y1: "116.78",
  x2: "258.27",
  y2: "137.21"
}, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("line", {
  class: "logo-wing-line",
  x1: "370.38",
  y1: "112",
  x2: "330.98",
  y2: "130.94"
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("line", {
  class: "logo-wing-line",
  x1: "372.16",
  y1: "113.2",
  x2: "335.85",
  y2: "88.53"
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("line", {
  class: "logo-wing-line",
  x1: "311.89",
  y1: "165.69",
  x2: "258.18",
  y2: "176.82"
}, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("line", {
  class: "logo-wing-line",
  x1: "354",
  y1: "157.01",
  x2: "311.62",
  y2: "164.82"
}, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("line", {
  class: "logo-wing-line",
  x1: "262.08",
  y1: "94.62",
  x2: "291.42",
  y2: "116.78"
}, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("line", {
  class: "logo-wing-line",
  x1: "335.85",
  y1: "89.39",
  x2: "331.78",
  y2: "131.34"
}, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("line", {
  class: "logo-wing-line",
  x1: "378.78",
  y1: "61.99",
  x2: "370.26",
  y2: "112.74"
}, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("line", {
  class: "logo-wing-line",
  x1: "422.03",
  y1: "43.77",
  x2: "405.95",
  y2: "74.32"
}, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("line", {
  class: "logo-wing-line",
  x1: "221.6",
  y1: "163.59",
  x2: "258.17",
  y2: "137.21"
}, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("line", {
  class: "logo-wing-line",
  x1: "197.71",
  y1: "187.37",
  x2: "221.6",
  y2: "163.59"
}, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("line", {
  class: "logo-wing-line",
  x1: "240.81",
  y1: "206.52",
  x2: "258.17",
  y2: "177.12"
}, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("line", {
  class: "logo-wing-line",
  x1: "258.27",
  y1: "177.12",
  x2: "282.1",
  y2: "203.83"
}, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("line", {
  class: "logo-wing-line",
  x1: "282.51",
  y1: "206.64",
  x2: "307.39",
  y2: "232.74"
}, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("line", {
  class: "logo-wing-line",
  x1: "333.82",
  y1: "68.24",
  x2: "335.85",
  y2: "88.53"
}, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("line", {
  class: "logo-wing-line",
  x1: "223.54",
  y1: "166.61",
  x2: "242.2",
  y2: "204.16"
}, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("line", {
  class: "logo-wing-line",
  x1: "242.2",
  y1: "204.17",
  x2: "283.67",
  y2: "205.59"
}, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("line", {
  class: "logo-wing-line",
  x1: "290.82",
  y1: "116.58",
  x2: "331.78",
  y2: "131.34"
}, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("line", {
  class: "logo-wing-line",
  x1: "378.11",
  y1: "61.34",
  x2: "404.35",
  y2: "73.32"
}, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("line", {
  class: "logo-wing-line",
  x1: "335.85",
  y1: "89.39",
  x2: "262.08",
  y2: "94.62"
}, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("line", {
  class: "logo-wing-line",
  x1: "441.9",
  y1: "31.22",
  x2: "413.01",
  y2: "43.93"
}, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("line", {
  class: "logo-wing-line",
  x1: "381.05",
  y1: "53.54",
  x2: "413.01",
  y2: "43.93"
}, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("line", {
  class: "logo-wing-line",
  x1: "333.82",
  y1: "68.24",
  x2: "381.05",
  y2: "53.54"
}, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("line", {
  class: "logo-wing-line",
  x1: "262.08",
  y1: "92.01",
  x2: "333.82",
  y2: "68.24"
}, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("line", {
  class: "logo-wing-line",
  x1: "258.27",
  y1: "137.21",
  x2: "227.98",
  y2: "127"
}, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("circle", {
  class: "logo-eye",
  cx: "103.57",
  cy: "221.66",
  r: "10"
}, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("circle", {
  class: "logo-border-point",
  cx: "165.07",
  cy: "209.16",
  r: "8"
}, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("circle", {
  class: "logo-border-point",
  cx: "193.07",
  cy: "188.16",
  r: "8"
}, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("circle", {
  class: "logo-border-point",
  cx: "330.07",
  cy: "153.16",
  r: "8"
}, null, -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("circle", {
  class: "logo-wing-dot",
  cx: "259.07",
  cy: "254.16",
  r: "9"
}, null, -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("circle", {
  class: "logo-wing-dot",
  cx: "378.07",
  cy: "60.16",
  r: "9"
}, null, -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("circle", {
  class: "logo-wing-dot",
  cx: "258.57",
  cy: "176.66",
  r: "8"
}, null, -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("circle", {
  class: "logo-wing-dot",
  cx: "305.57",
  cy: "229.66",
  r: "8"
}, null, -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("circle", {
  class: "logo-wing-dot",
  cx: "282.57",
  cy: "205.66",
  r: "8"
}, null, -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("circle", {
  class: "logo-wing-dot",
  cx: "291.57",
  cy: "116.66",
  r: "8"
}, null, -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("circle", {
  class: "logo-wing-dot",
  cx: "258.57",
  cy: "137.66",
  r: "8"
}, null, -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("circle", {
  class: "logo-wing-dot",
  cx: "405.57",
  cy: "74.66",
  r: "8"
}, null, -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("circle", {
  class: "logo-wing-dot",
  cx: "370.57",
  cy: "111.66",
  r: "8"
}, null, -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("circle", {
  class: "logo-wing-dot",
  cx: "324.57",
  cy: "196.66",
  r: "8"
}, null, -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("circle", {
  class: "logo-wing-dot",
  cx: "228.57",
  cy: "128.66",
  r: "8"
}, null, -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("circle", {
  class: "logo-wing-dot",
  cx: "312.57",
  cy: "165.66",
  r: "12"
}, null, -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("circle", {
  class: "logo-wing-dot",
  cx: "330.57",
  cy: "130.66",
  r: "12"
}, null, -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("circle", {
  class: "logo-wing-dot",
  cx: "221.57",
  cy: "163.66",
  r: "12"
}, null, -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("circle", {
  class: "logo-wing-dot",
  cx: "242.57",
  cy: "204.66",
  r: "12"
}, null, -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("circle", {
  class: "logo-wing-dot",
  cx: "335.57",
  cy: "89.66",
  r: "12"
}, null, -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("circle", {
  class: "logo-wing-dot",
  cx: "262.57",
  cy: "94.66",
  r: "12"
}, null, -1)
const _hoisted_63 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8,
  _hoisted_9,
  _hoisted_10,
  _hoisted_11,
  _hoisted_12,
  _hoisted_13,
  _hoisted_14,
  _hoisted_15,
  _hoisted_16,
  _hoisted_17,
  _hoisted_18,
  _hoisted_19,
  _hoisted_20,
  _hoisted_21,
  _hoisted_22,
  _hoisted_23,
  _hoisted_24,
  _hoisted_25,
  _hoisted_26,
  _hoisted_27,
  _hoisted_28,
  _hoisted_29,
  _hoisted_30,
  _hoisted_31,
  _hoisted_32,
  _hoisted_33,
  _hoisted_34,
  _hoisted_35,
  _hoisted_36,
  _hoisted_37,
  _hoisted_38,
  _hoisted_39,
  _hoisted_40,
  _hoisted_41,
  _hoisted_42,
  _hoisted_43,
  _hoisted_44,
  _hoisted_45,
  _hoisted_46,
  _hoisted_47,
  _hoisted_48,
  _hoisted_49,
  _hoisted_50,
  _hoisted_51,
  _hoisted_52,
  _hoisted_53,
  _hoisted_54,
  _hoisted_55,
  _hoisted_56,
  _hoisted_57,
  _hoisted_58,
  _hoisted_59,
  _hoisted_60,
  _hoisted_61,
  _hoisted_62
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("g", _hoisted_1, _hoisted_63))
}